<template>
  <Adsense
    class="RwvAdvertisement"
    :data-ad-client="ad_client"
    :data-ad-slot="ad_slot"
    data-ad-test="on"
    data-ad-format="auto">
  </Adsense>
</template>

<script>
export default {
  name: 'RwvAdvertisement',
  props: {
    ad_client: {
      type: String,
      required: true
    },
    ad_slot: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.RwvAdvertisement {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
